import { memo } from "react";
import { Button, Input, Header } from "pfm-core";
import { cn } from "./utils/cn";
import "./styles.css";

const App = memo(() => {
  return (
    <div className="bg-background">
      <h1 className={cn("mb-8 text-3xl text-destructive")}>Dashboard</h1>
      <Header />
      <Button variant="outline" onClick={() => alert("clicked")} size={"lg"}>
        Click
      </Button>
      <form>
        <Input type="email" placeholder="Email" />
      </form>
    </div>
  );
});

App.displayName = "App";

export default App;
